
import { getPrefix, getSessionToken } from "../bandung";
import { objectToFormData } from "./helpers";
import Axios from "axios";

const getContactPrefix = () => `${getPrefix()}/app/contact`;

const getContactCreateEndPoint = () => `${getContactPrefix()}/create`;
const getContactDeleteEndPoint = () => `${getContactPrefix()}/delete`;
const getContactListEndPoint = () => `${getContactPrefix()}/list`;
const getContactTextLongDescriptionEndPoint = () => `${getContactPrefix()}/textlongdescription`;
const getContactUpdateEndPoint = () => `${getContactPrefix()}/update`;
const getContactUpdateLongDescriptionEndPoint = () => `${getContactPrefix()}/updatelongdescription`;
const getContactViewEndPoint = () => `${getContactPrefix()}/view`;

const contactCreate = async ({
  useSessionInfo,
  firstName,
  lastName,
  email,
  phone,
  request,
  status,
  longDescription,
}) => {
  const form = objectToFormData({
    sessionToken: useSessionInfo ? getSessionToken() : null,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phone: phone,
    request: request,
    status: status,
    longDescription: encodeURIComponent(longDescription),
  });
  try {
    const response = await Axios.post(getContactCreateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Contact successfully created.",
        data: { contactEntityId: response.data.contactEntityId },
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactDelete = async (contactEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    contactEntityId: contactEntityId,
  });
  try {
    const response = await Axios.post(getContactDeleteEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Contact deleted successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactList = async (page) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    page: page,
  });
  try {
    const response = await Axios.post(getContactListEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Contact list loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactTextLongDescription = async (contactEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    contactEntityId: contactEntityId,
  });
  try {
    const response = await Axios.post(
      getContactTextLongDescriptionEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Long description retrieved successfully.",
        data: decodeURIComponent(response.data),
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactUpdate = async ({
  contactEntityId,
  userEntityId,
  firstName,
  lastName,
  email,
  phone,
  request,
  status,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    contactEntityId: contactEntityId,
    userEntityId: userEntityId,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phone: phone,
    request: request,
    status: status,
  });
  try {
    const response = await Axios.post(getContactUpdateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Update successful.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactUpdateLongDescription = async (
  contactEntityId, longDescription) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    contactEntityId: contactEntityId,
    longDescription: encodeURIComponent(longDescription),
  });
  try {
    const response = await Axios.post(
      getContactUpdateLongDescriptionEndPoint(),
      form);
    if (response.data.entity) {
      return {
        code: "SUCCESS",
        message: "Long description updated successfully.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const contactView = async (contactEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    contactEntityId: contactEntityId,
  });
  try {
    const response = await Axios.post(getContactViewEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Contact loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export {
  contactCreate,
  contactDelete,
  contactList,
  contactTextLongDescription,
  contactUpdate,
  contactUpdateLongDescription,
  contactView,
};
